import React, { useState, useEffect } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import Layout from "../components/Layout";
import location from "../assets/svgs/location.svg";
import downArrow from "../assets/svgs/downArrow.svg";
import Button from "../components/Button";
import ProfileCard from "../components/ProfileCard";
import MapComponent from "../components/MapComponent";
import AutoAddressComponent from "../components/AutoAdressComponent";
import { useSearchParams } from "react-router-dom";

const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY; // Replace with your Google API Key

function Locations() {
  const [searchParams] = useSearchParams();
  const initialZip = searchParams.get("zip") || "";
  const [address, setAddress] = useState(initialZip); // Selected address
  const [doctors, setDoctors] = useState([]); // List of nearby doctors
  const [error, setError] = useState(null); // Error message
  const [loading, setLoading] = useState(false); // Loading state
  const [searchedLocation, setSearchedLocation] = useState(null); 

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleApiKey,
    id: "google-map-script",
    libraries: ["places"],
  });
  const handlePlaceSelected = (selectedAddress) => {
    setAddress(selectedAddress);
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: selectedAddress }, (results, status) => {
      if (status === "OK" && results.length > 0) {
        const location = results[0].geometry.location;
        setSearchedLocation({ lat: location.lat(), lng: location.lng() });
      } else {
        console.error("Geocode error:", status);
        setError("Unable to find location. Please try again.");
      }
    });
  };

  const fetchDoctors = async () => {
    if (!address) {
      setError("Please select an address to search.");
      return;
    }
    try {
      setLoading(true);
      setError(null);

      const response = await fetch(
        `https://backend-58742455872.us-central1.run.app/api/v1/doctors/nearby?address=${address}`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch doctors");
      }

      const data = await response.json();
      setDoctors(data.doctors);
    } catch (err) {
      console.error("Error fetching doctors:", err.message);
      setError("Unable to fetch nearby doctors. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (address) {
      fetchDoctors(); // Automatically fetch doctors when an address is selected
    }
  }, [address]);

  return (
    <Layout>
      <div className="flex  gap-4 flex-col md:flex-row  justify-center items-center px-4 py-4 md:px-14 md:py-5 bg-[#F7F7F7]">
        <div className="flex-1   p-4 md:p-6 flex flex-col gap-4">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold md:font-semibold leading-[33.6px] tracking-[0.005em] text-left text-primaryBlue90 overflow-y-hidden">
              Dental Second Opinion Near You
            </h3>
            <h6 className="text-sm font-medium text-neutral60 md:text-base md:font-semibold mt-2">
              Enter your location below to discover trusted dentists in your
              area
            </h6>
          </div>
          <div className=" p-2 rounded-[34px] bg-white flex justify-between items-center gap-2">
            <div className="py-1 px-2 flex justify-start items-center gap-2 flex-1">
              <div className="w-6 h-6">
                <img src={location} className="w-full h-full px-1 py-[1px]" />
              </div>
              <AutoAddressComponent
                isLoaded={isLoaded}
                onPlaceSelected={handlePlaceSelected}
                zip={initialZip}
              />
            </div>
            <Button text="Search" onClick={fetchDoctors} />
          </div>

          <div className="mt-3 flex flex-col gap-2">
            {loading ? (
              <div className="text-center">Loading nearby doctors...</div>
            ) : error ? (
              <div className="text-center text-red-500">{error}</div>
            ) : doctors.length > 0 ? (
              <>
                <div className="flex justify-between items-center">
                  <div className="text-sm font-medium text-neutral80 md:text-base">
                    {doctors.length} Dentists Found
                  </div>
                  <div className="flex justify-end gap-3">
                    <div className="text-sm font-medium text-neutral60 md:text-base">
                      Sort by:
                    </div>
                    <div className="flex justify-end gap-3">
                      <div className="text-sm font-medium text-neutral80 md:text-base">
                        Nearest
                      </div>
                      <div className="w-6 h-6 px-1 py-2 cursor-pointer">
                        <img src={downArrow} className="w-full h-full" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="max-h-[1391px] md:max-h-[597px] flex flex-col gap-4 overflow-y-scroll pb-4">
                  {doctors.map((doctor) => (
                    <ProfileCard
                      key={doctor._id}
                      id={doctor._id}
                      profileImage={doctor.profileImg}
                      name={doctor.name}
                      speciality={doctor.speciality}
                      yearsOfExperience={doctor.yearsOfExperience}
                      address={doctor.address}
                      description={doctor.description}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center">No doctors found in your area.</div>
            )}
          </div>
        </div>
        <div className="flex-1 min-h-[500px] rounded-[48px] overflow-hidden self-stretch">
          <MapComponent doctorLocations={doctors} searchedLocation={searchedLocation} />
        </div>
      </div>
    </Layout>
  );
}

export default Locations;
